import { Swiper } from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Hero component functionality
class Hero {
  constructor() {
    this.hero = document.querySelector('[data-js="hero"]');
    this.carouselDots = document.querySelectorAll('.hero__carousel-dot');
    this.swiper = null;
    
    if (!this.hero) return;
    
    this.init();
  }
  
  init() {
    this.initSwiper();
    this.bindEvents();
  }
  
  initSwiper() {
    this.swiper = new Swiper('.hero__swiper', {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 800,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      on: {
        slideChange: (swiper) => {
          this.updateDots(swiper.realIndex);
        }
      }
    });
  }
  
  bindEvents() {
    // Carousel dot navigation
    this.carouselDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        if (this.swiper) {
          this.swiper.slideToLoop(index);
        }
      });
    });
  }
  
  updateDots(activeIndex) {
    // Remove active class from all dots
    this.carouselDots.forEach(dot => {
      dot.classList.remove('hero__carousel-dot--active');
    });
    
    // Add active class to current dot
    if (this.carouselDots[activeIndex]) {
      this.carouselDots[activeIndex].classList.add('hero__carousel-dot--active');
    }
  }
}

export { Hero };
